export type GreetingPresentationMode = 'normal' | 'deepResearch' | 'taskMode';
export type PersonalityGreetingMode = 'normal' | 'thinkDeeper' | 'taskMode';

type GreetingModeState = {
	deepResearchEnabled: boolean;
	thinkDeeperEnabled?: boolean;
	taskModeEnabled: boolean;
};

type GreetingModes = {
	presentationMode: GreetingPresentationMode;
	personalityMode: PersonalityGreetingMode;
};

/**
 * Resolves the presentation branch and personality copy bucket from one priority order.
 * Deep research keeps its dedicated presentation and uses the normal personality copy.
 */
export const getGreetingModes = ({
	deepResearchEnabled,
	thinkDeeperEnabled = false,
	taskModeEnabled,
}: GreetingModeState): GreetingModes => {
	if (deepResearchEnabled) {
		return { presentationMode: 'deepResearch', personalityMode: 'normal' };
	}
	if (taskModeEnabled) {
		return { presentationMode: 'taskMode', personalityMode: 'taskMode' };
	}
	if (thinkDeeperEnabled) {
		return { presentationMode: 'normal', personalityMode: 'thinkDeeper' };
	}
	return { presentationMode: 'normal', personalityMode: 'normal' };
};
